const updateItems = [
  {
    time: '10分钟前',
    title: '千万粉丝美食博主后厨卫生翻车，前员工实名举报使用过期食材',
    summary: '拥有1200万粉丝的知名美食博主被前员工曝光后厨使用过期食材、虚假宣传有机食品，品牌方已紧急暂停合作。',
  },
  {
    time: '28分钟前',
    title: '某男团成员深夜密会素人被拍，粉丝站集体宣布关站',
    summary: '当红男团成员被拍到与素人女性深夜同行，多家粉丝站发表联合声明宣布暂停应援活动。',
  },
  {
    time: '1小时前',
    title: '带货一姐直播间翻车，宣称「纯金」饰品检测结果为铜合金',
    summary: '第三方检测机构出具报告确认争议商品材质与宣传严重不符，相关监管部门已介入调查。',
  },
  {
    time: '2小时前',
    title: '电竞圈大瓜：冠军战队内部不和录音曝光，疑似即将解散',
    summary: '一段疑似冠军战队内部会议录音流出，多名成员激烈争执，业内人士分析战队可能面临重组。',
  },
  {
    time: '3小时前',
    title: '某知名情感博主被扒「人设造假」，真实身份竟是已婚有子',
    summary: '靠「母单」人设走红的情感博主被网友扒出早年结婚证，人设崩塌引发粉丝大规模脱粉。',
  },
  {
    time: '5小时前',
    title: '娱乐圈年度最大反转：被骂「小三」三年的女星终获清白',
    summary: '法院判决书公开揭露当年事件真相，原配策划陷害证据确凿，女星沉冤得雪引发全网热议。',
  },
  {
    time: '7小时前',
    title: '海外留学生爆料某留学中介造假录取通知书，涉案金额超千万',
    summary: '多名留学生联合举报某知名留学中介伪造名校录取通知书，涉及数十名学生和超过千万元费用。',
  },
  {
    time: '9小时前',
    title: '健身圈大佬人设崩塌，被爆药物使用史与虚假自然健身宣传',
    summary: '前合作伙伴提供大量证据证明该博主长期使用违禁药物却对外宣称自然健身，代言品牌面临集体诉讼。',
  },
  {
    time: '12小时前',
    title: '某知识付费大V课程内容被指抄袭，原作者发起维权',
    summary: '多名原创作者联合声明指出该大V多门付费课程内容大量抄袭，部分章节雷同度超80%。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-20 md:py-28 bg-background-700">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 mb-14">
          动态快讯：24h 吃瓜滚动
        </h2>

        <div className="relative pl-8 md:pl-12">
          <div className="absolute left-[7px] md:left-[11px] top-2 bottom-2 w-[2px] bg-accent-500/40"></div>

          <div className="flex flex-col gap-8">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative">
                <div className="absolute -left-[31px] md:-left-[35px] top-3 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-700"></div>

                <div className="bg-background-700 rounded-xl p-5 border border-foreground-900/8 hover:border-accent-500/40 transition-all duration-300 cursor-default">
                  <span className="inline-block px-3 py-1 rounded-full bg-foreground-950 text-background-50 text-[11px] font-bold mb-3">
                    {item.time}
                  </span>
                  <h3 className="text-base font-bold text-foreground-950 font-heading mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}